/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{DataType as e}from"../../../webgl/enums.js";import{VertexElementDescriptor as o}from"../../../webgl/VertexElementDescriptor.js";const r={geometry:[new o("a_pos",2,e.BYTE,0,2)]},t={geometry:[new o("a_pos",2,e.BYTE,0,4),new o("a_tex",2,e.BYTE,2,4)]},m={geometry:[new o("a_pos",2,e.UNSIGNED_SHORT,0,4)]};export{r as Pos2b,m as Pos2us,t as PosTex2b};
